var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",attrs:{"id":"footer-info"}},[(_vm.config.shop_type == 1)?_c('parent-footer',{attrs:{"config":_vm.config}}):_vm._e(),_vm._v(" "),(_vm.config.shop_type == 0)?_c('son-footer',{attrs:{"config":_vm.config}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5407787c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/Footer.vue
// module id = null
// module chunks = 